import { excavation } from './excavation'
import { commitment } from './commitment'
import { entitydb } from './entitydb'
import { entitydbCd } from './entitydbCd'
import { entitydbLa } from './entitydbLa'
import { entitydbRt } from './entitydbRt'
import { aacpVi } from './cashManagement/aacpVi'
import { aafliii } from './cashManagement/aafliii'
import { ivoryIv } from './cashManagement/ivoryIv'
import { MDIv } from './cashManagement/MDIv'

const sqlTables = {
    excavation: excavation,
    commitment: commitment,
    entitydb: entitydb,
    entitydbCd: entitydbCd,
    entitydbLa: entitydbLa,
    entitydbRt: entitydbRt,
    aacpVi: aacpVi,
    aafliii: aafliii,
    ivoryIv: ivoryIv,
    MDIv: MDIv
}
export { sqlTables }
